import dashboardRoutes from "./children/dashboard";
import modulesRoutes from "./children/modules";
import moduleManagementRoutes from "./children/moduleManagement";
import rolesRoutes from "./children/roles";
import applicationRoutes from "./children/application";
import usersRoutes from "./children/users";
import pagesRoutes from "./children/pages";

// Main layout routes grouped by domain
export default [
  {
    path: "",
    component: () => import("@/layouts/main/Main.vue"),
    children: [
      ...dashboardRoutes,
      ...modulesRoutes,
      ...moduleManagementRoutes,
      ...rolesRoutes,
      ...applicationRoutes,
      ...usersRoutes,
      ...pagesRoutes,
    ]
  }
];

